import {ActionTypes, GetterTypes, MutationTypes} from '@/modules/neopvc/store/types';

import {projectService} from '@/modules/neopvc/services/project.service';
import {Project} from '@/modules/neopvc/models';
import {tabs} from '@/modules/neopvc/models';
import {AuditEntry} from '@/modules/neopvc/models/auditEntry';

interface State {
  projects: Project[];
  auditEntries: AuditEntry[];
  currentTab: string;
  newProject: boolean;
}

const initialState = {
  projects: [],
  auditEntries: [],
  currentTab: tabs.list,
  newProject: false,
};

const defaultLocale = 'pt-BR';

const storeState = (): State => ({...initialState});

const getters = {
  [GetterTypes.GET_CURRENT_TAB](state: State): string {
    return state.currentTab;
  },

  [GetterTypes.GET_PROJECTS](state: State): Project[] {
    return state.projects;
  },

  [GetterTypes.GET_AUDIT_ENTRIES](state: State): AuditEntry[] {
    return state.auditEntries;
  },

  [GetterTypes.GET_NEW_PROJECT](state: State): boolean {
    return state.newProject;
  },
};

const mutations = {
  [MutationTypes.SET_PROJECTS](state: State, payload: Project[]) {
    state.projects = payload;
  },
  [MutationTypes.SET_AUDIT_ENTRIES](state: State, payload: AuditEntry[]) {
    state.auditEntries = payload;
  },
  [MutationTypes.SET_CURRENT_TAB](state: State, payload: string) {
    state.currentTab = payload;
  },
  [MutationTypes.SET_NEW_PROJECT](state: State, payload: boolean) {
    state.newProject = payload;
  },
};

const actions = {
  [ActionTypes.FETCH_AUDIT_ENTRIES]({commit}: any): void {
    projectService
      .getAuditEntries()
      .then((response: any) => response.data)
      .then((data: AuditEntry[]) => data.map((x: AuditEntry) => ({
        ...x,
        startedAt: x.startedAt,
        finalizedAt: x.finalizedAt,
      })))
      .then((data: AuditEntry[]) => commit(MutationTypes.SET_AUDIT_ENTRIES, data));
  },

  [ActionTypes.FETCH_PROJECTS]({commit}: any): void {
    projectService
      .getProjects()
      .then((response: any) => response.data)
      .then((data: Project[]) => data.map((d: Project) => ({
        ...d,
        dateStartDistribution: new Date(d.dateStartDistribution).toLocaleDateString(defaultLocale),
        dateEndDistribution: new Date(d.dateEndDistribution).toLocaleDateString(defaultLocale),
        dateReference: new Date(d.dateReference).toLocaleDateString(defaultLocale),
      })))
      .then((data: Project[]) => commit(MutationTypes.SET_PROJECTS, data));
  },

  [ActionTypes.SAVE_NEW_PROJECT]({commit}: any, payload: Project): Promise<void> {
    return projectService.saveNewProject(payload)
      .then(() => Promise.resolve())
      .catch(() => Promise.reject());
  },

  [ActionTypes.UPDATE_CURRENT_TAB]({commit}: any, payload: string): void {
    commit(MutationTypes.SET_CURRENT_TAB, payload);
  },

  [ActionTypes.UPDATE_NEW_PROJECT]({commit}: any, payload: boolean): void {
    commit(MutationTypes.SET_NEW_PROJECT, payload);
  },

  [ActionTypes.CALCULATE_PROJECT_DESTINY]({commit}: any, payload: Project): Promise<void> {
    return projectService.calculateProjectDestiny(payload)
      .then(() => Promise.resolve())
      .catch(() => Promise.reject());
  },

  [ActionTypes.CALCULATE_PROJECT_ORIGIN]({commit}: any, payload: Project): Promise<void> {
    return projectService.calculateProjectOrigin(payload)
      .then(() => Promise.resolve())
      .catch(() => Promise.reject());
  },
};

export default {
  namespace: true,
  state: storeState,
  getters,
  mutations,
  actions,
};
